@if (!showApplicationChrome()) {
  <router-outlet />
} @else if (showSignInExperience()) {
  <section class="sign-in-page">
    <div class="sign-in-shell">
      <div class="sign-in-card">
        <div class="sign-in-card-top">
          <div class="sign-in-atb-brand" aria-label="ATB Assurant Trade Bridge">
            <app-logo />
          </div>
          <div class="sign-in-assurant" aria-label="Assurant">
            <img
              class="sign-in-assurant-logo"
              src="/assets/branding/Assurant_Logo.png"
              alt="Assurant"
            />
          </div>
        </div>

        <div class="sign-in-card-copy">
          <h1>Every Marketplace.<br />All Channels.</h1>
          <p>Unified channel platform for tracking orders, returns and AVR operations.</p>
        </div>

        <div class="sign-in-feature-list">
          <div class="sign-in-feature-item">Near real-time order visibility across all platforms</div>
          <div class="sign-in-feature-item">Multi-region and multi-channel coverage in one platform</div>
        </div>

        <button type="button" class="sign-in-primary" (click)="signIn()">
          Sign In
        </button>
      </div>
    </div>
  </section>
} @else {
  <div stack-layout [fullHeight]="true" [fullWidth]="true" color="primary-surface">
    <div
      row-layout
      [fullWidth]="true"
      color="primary"
      paddingVertical="md"
      paddingHorizontal="xl"
      justifyContent="space-between"
      alignItems="center"
    >
      <div box-layout style="padding-top: 6px">
        <app-logo />
      </div>

      <app-user-menu />
    </div>
    <div row-layout [grow]="1" [fullWidth]="true" style="min-width: 0; min-height: 0; overflow-x: hidden">
      @if (!nav.hideNavigation()) {
        <div box-layout style="flex: 0 0 280px; min-width: 280px; max-width: 280px; overflow: hidden">
          <app-navigation-menu />
        </div>
      }
      <div box-layout [grow]="1" style="min-width: 0; min-height: 0; overflow-x: auto; overflow-y: visible">
        <router-outlet />
      </div>
    </div>
    <div page-footer></div>
  </div>
}
<Notifications />
